import { Campaign } from "../../types/sponsorships/campaigns"
import GenderIcon from "../icons/GenderIcon"
import StrategyIcon from "../icons/StrategyIcon"
import { formatNumber, textToTitleCase } from "../../utils/helpers"
import ClickableImage from "../misc/ClickableImage"
import { platformLogos } from "../../pages/Campaign"

const SponsorshipDetails: React.FC<{ followers_count: number, gender: string, strategy: string, hidden: boolean }> = ({ followers_count, gender, strategy, hidden }) => {
    
    if(hidden) return <></>

    return (
        <div className="row mt-3 mb-0 text-center">
            <div className="col-4 p-0">
                <span className="chip mb-2 bg-gray-light">
                    <GenderIcon gender={gender} additionalClasses="color-white bg-blue-dark" />
                    <strong className="color-black font-400">{gender}</strong>
                </span>
                <p className="font-10 mb-0 pb-0">Gender</p>
            </div>
            <div className="col-4 p-0">
                <span className="chip mb-2 bg-gray-light">
                    <i className="fab fa-instagram color-white bg-instagram"></i>
                    <strong className="color-black font-400">{followers_count}+</strong>
                </span>
                <p className="font-10 mb-0 pb-0">Followers</p>
            </div>
            <div className="col-4 p-0">
                <span className="chip mb-2 bg-gray-light">
                    <StrategyIcon strategy={strategy} />
                    <strong className="color-black font-400">{textToTitleCase(strategy)}</strong>
                </span>
                <p className="font-10 mb-0 pb-0">Strategy</p>
            </div>
        </div>
    )
}


const SponsorshipCard: React.FC<Campaign> = ({ uuid, name, gender_name, strategy, requirement, hero_img_url, platform, budget, barter_budget }) => {
    return (
        <div className="card card-style mb-3">
            <div className="content">
                <ClickableImage imageURL={hero_img_url} path={`/campaign/${uuid}`} />
                <div className="d-flex align-items-center gap-2 justify-content-between mt-n2 mb-1">
                    <img src={platformLogos[platform as keyof typeof platformLogos]} className={`${platform === 'ig' ? 'ms-n1' : ''}`} height={platform === 'ig' ? 35 : 25} />
                    <span>Budget: <span className="fw-bold">₹{formatNumber((Number(budget ?? 0) + (Number(barter_budget ?? 0))))}</span></span>
                </div>
                <h4>{name}</h4>
                {/* <SponsorshipDetails hidden={true} strategy={strategy} gender={gender_name} followers_count={requirement.follower_count} /> */}
            </div>
        </div>
    )
}
export default SponsorshipCard